console.log("hp_products_slider");
$(".products-hp")
  .find(".products")
  .slick({
    dots: false,
    arrows: true,
    infinite: false,
    variableWidth: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: ".products-hp__nav--left",
    nextArrow: ".products-hp__nav--right",
    responsive: [
      {
        breakpoint: 900,
        settings: "unslick"
      },
    ],
  });
